/**
 * nuauge-card-hover-gallery.js
 * Alterna entre as imagens do produto ao passar o mouse sobre o card (desktop).
 * Substitui o sistema de <slideshow> web-component do tema antigo por algo mais leve,
 * sem depender de View Transitions nem de custom elements complexos.
 */
(function () {
  var INTERVAL_MS = 900;

  function initGallery(el) {
    if (el.dataset.nuaugeGalleryInit) return;
    var raw = el.getAttribute('data-nuauge-gallery');
    if (!raw) return;

    var images;
    try {
      images = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!images || !images.length) return;

    el.dataset.nuaugeGalleryInit = '1';

    var mainImg = el.querySelector('img');
    if (!mainImg) return;

    var originalSrc = mainImg.getAttribute('src');
    var originalSrcset = mainImg.getAttribute('srcset');
    var index = 0;
    var timer = null;

    function preload() {
      images.forEach(function (src) {
        var i = new Image();
        i.src = src;
      });
    }

    function next() {
      index = (index + 1) % images.length;
      mainImg.removeAttribute('srcset');
      mainImg.setAttribute('src', images[index]);
    }

    function start() {
      preload();
      timer = setInterval(next, INTERVAL_MS);
    }

    function stop() {
      clearInterval(timer);
      index = 0;
      mainImg.setAttribute('src', originalSrc);
      if (originalSrcset) mainImg.setAttribute('srcset', originalSrcset);
    }

    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      start();
    });
    el.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      stop();
    });
  }

  function scan() {
    document.querySelectorAll('.nuauge-hover-gallery:not([data-nuauge-gallery-init])').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Reobserva quando novos cards entram na página (paginação, filtros, seções recarregadas via AJAX nativo do Dawn)
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      scan();
    }, 250);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
